import { gql } from "@apollo/client";

export const SUBSCRIPTION_FRAGMENT = gql`
  fragment SubscriptionFragment on Subscription {
    id
    plan
    billingInterval
    status
    hasReachedAssetThreshold
    assetThresholdPercent
    nextBillingDate
  }
`;
